// extracted by mini-css-extract-plugin
export default {"connection-successful-form":"J75RnT","connectionSuccessfulForm":"J75RnT"};